export default __webpack_public_path__ + "static/baskervi-5e6fafedfe18449e4be10ed68996cb52.woff";